// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/images/s_ic.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/images/games.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/images/champion.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/images/zuppe.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/images/vs_screen_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/images/vs_bg_2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  font-family: "Poppins", sans-serif;
}
body{
  background: #181818;
  overflow-x: hidden !important;
}
button, input, optgroup, select, textarea{
  font-family: "Poppins", sans-serif !important;
}
.section {
  display: flex;
  height: 100vh;
  align-items: center;
  overflow: hidden;
  padding: 0 !important;
}
.s_left {
  /* background: url(../images/white_bg.png); */
  background: #181818;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 480px;
  width: 100%;
  overflow-x: hidden !important;
  overflow-y: scroll;
  height: 100vh;
  scroll-behavior: smooth;
}
@media screen and (max-width: 900px){
  .s_left {
      max-width: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
  }
}

@media screen and (max-width: 600px){
  .s_left {
      width: 100%;
  }
}
.s_right {
  display: grid;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  justify-items: center;
  background: linear-gradient(135deg, #000000, #000000);
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  background-position: center;
  color: #ffffff;
}
@media screen and (max-width: 900px){
  .s_right {
      display: none !important;
  }
}

@media screen and (max-width: 600px){
  .s_right {
      display: none !important;
  }
  
}

/* scroll bar */
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #fff3f8; 
}
::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #ffffff, #ffffff);
  border-radius: 6px;
}

/* header */
.header {
  height: 60px;
}
nav {
  position: fixed;
  z-index: 9;
  max-width: 474px;
  background: #282828 !important;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}
.h_left {
  display: flex;
  align-items: center;
  width: 100% !important;
  margin-top: 12px;
}
.hamburger {
  width: auto;
  height: 40px;
}
.sidenav-trigger {
  display: block !important;
}
.logo{
  width: auto;
  height: 35px;
  margin-left: 10px;
  margin-top: 10px;
}
.h_right {
  display: flex;
  width: 60%;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 10px;
  gap: 0.5rem;
}
.h_right >a > img{
  width: auto;
  height: 24px;
  margin-right: 10px;
  margin-top: 10px;
  cursor: pointer;
}
.h_right >p{
  margin-right: 10px;
  margin-top: -5px;
  cursor: pointer;
}
.daily_st{
  background: #ffffff;
  box-shadow: 0px 0px 12px #319bd92e;
  width: 100%;
  border-radius: 10px;
}

.body_sec{
  padding: 0px 15px;
}

/* daily streak */
.daily_st{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}

.s_l_ttl{
  background: #dcefff;
  padding: 0px 0px 0px 5px;
  border-radius: 5px;
  font-size: 12px;
  color: #282828;
  font-weight: 500;
  display: flex;
  align-items: center;
  display: inline-flex;
}
.mr_l5{
  margin-left: 5px;
}
.s_ic_list{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  width: 20px;
  height: 20px;
  text-align: center;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.s_ic_list >p{
  font-size: 10px;
  font-weight: 700;
}
.s_ic_list >img{
  position: absolute;
  height: 24px;
}

.st_ic_d{
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.task_cmp{
  border: 1px solid #cfcfcf;
  border-radius: 5px;
  margin-top: 10px;
  padding: 0px 10px;
}
.task_cmp > p{
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
  color: #464646;
}
.task_cmp >p > img{
  width: auto;
  height: 15px;
  margin: 0px 10px;
}
.desc_sm{
  font-size: 10px;
  color: #464646;
  font-weight: 400;
  margin-top: 10px;
}

.streak_r > p > img{
  width: auto;
  height: 30px;
}
.streak_r > p{
  display: flex;
  align-items: center;
  border: 1px solid #cfcfcf;
  border-radius: 50px;
  padding: 0px 10px 0px 0px;
  background: #f3f3f3;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}

.top_b{
  width: 100%;
  height: auto;
  border-radius: 20px;
  margin-top: 20px;
  max-height: 250px;
}


/* quiz items listing */
.h_quiz_list{
  background: #ffe4e4;
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px;
}
.list_c_2{
  background: #d6f7ff;
}
.q_l_head{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.l_ttl{
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 10px;
}
.see_all{
  font-size: 12px;
  color: #363636;
  font-weight: 500;  
}

.l_items{
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.l_item{
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
}
.l_item >img{
  width: auto;
  height: 70px;
  border-radius: 10px;
}

.l_item2 >img{
  width: auto;
  height: 200px;
  border-radius: 10px;
  margin-top: 10px;
  cursor: pointer;
}
.l_item3{
  cursor: pointer;
}
.l_item3 >img{
  width: auto;
  height: 150px;
  border-radius: 10px;
  margin-top: 10px;
}

.chllng{
  display: flex;
  align-items: center;
}
.chllng >a{
  margin-right: 10px;
  color: #282828;
  background: #cfcfcf;
  border-radius: 50px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 700;
}

.home_invite{
  width: 100%;
  height: 180px;
  border-radius: 30px;
  margin-top: 20px;
}


/* tournament page */
.trnmnt_header{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  height: 220px;
  margin-top: -10px;
}
.trnmnt_header >img{
  width: 100%;
  height: 250px;
}

.trnmt_list{
  padding: 10px;
  border-radius: 30px 30px 0px 0px;
  z-index: 999;
  height: 100%;
}

.trnm_list{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-repeat: no-repeat !important;
  background-position: center;
  height: 140px;
  border-radius: 10px;
  margin-top: 10px;
  padding: 10px 15px;
  border: 1px solid #282828;
}
.entr{
  display: flex;
  align-items: center;
  color: #ffffff;
  justify-content: space-between;
  text-align: center;
  /* width: 40%; */
  max-width: 60%;
  
}
.tour_ttl{
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
  margin: 0;
}
.entry_value > p{
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #b9b9b9;
}
.entry_value > p >img{
  width: auto;
  height: 20px;
  margin-right: 5px;
}

.etry_am{
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #ffffff !important;
}
.btn_white{
  background: #ffffff;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 30px;
  padding: 7px 20px;
  border: none;
  margin-top: 5px;
}

/* indicator */
.tabs .indicator {
  background-color: #319bd9 !important;
}

.tabs .tab a {
  color: #ffffff !important;
  font-weight: 500;
  font-size: 10px !important;
  text-transform: capitalize !important;
}

.tabs{
  border-radius: 50px;
  /* text-align: center; */
  background: #010101 !important;
  display: flex;
  justify-content: space-around;
  height: 40px;
  align-items: center;
  cursor: pointer;
}

/* Free coins section */
.campgn_item{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: 100% 0%!important;
  height: 200px;
  border-radius: 10px;
  margin-top: 10px;
  padding: 10px;
  display: grid;
  box-shadow: 0px 3px 12px #00000017;
  align-items: end;
}


.campgn_det{
  max-width: 50%;
}
.campgn_det >h2{
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  margin-bottom: 10px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.campgn_det >p{
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.campgn_stps{
  max-width: 60%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.campgn_stps > p{
  font-size: 10px;
  font-weight: bold;
  color: #282828;
  background: #dbdbdb;
  padding: 0px 10px;
  margin: 5px 5px 5px 0px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  
}
.campgn_stps > p >img{
  width: auto;
  height: 12px;
  margin: 0px 5px;
}

/* Blue Btn */
.btn_blue{
  background: #319bd9;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 5px;
}

.tabs .tab a:focus, .tabs .tab a:focus.active {
  background-color: #00a2ff0e !important;
  outline: none;
}

.no_task{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  font-size: 12px;
  font-weight: 500;
  color: #282828;
}

/* progreess Bar Circular */
.c_info_tabs{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.c_info_tab{
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-shadow: 0px 3px 6px #319bd947;
}
.c_info_tab >h2{
  font-size: 14px;
  font-weight: bold;
  color: #282828;
  margin: 0;
}
.progress_2 {
  width: 70px !important;
  height: 70px !important;
  font-size: 30px;
  color: #fff;
  border-radius: 50% !important;
  overflow: hidden !important;
  position: relative !important;
  background: #ffffff;
  text-align: center;
  margin: 10px !important;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  z-index: 1;
}


.progress_2 .title {
  position: relative;
  z-index: 100;
  margin: 0;
  margin-top: 12px;
}

.progress_2 .overlay {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: #ffffff;
}

.progress_2 .left, .progress_2 .right {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border: 10px solid #00a1ff;
  border-radius: 100px 0px 0px 100px;
  border-right: 0;
  transform-origin: right;
}

.progress_2 .left {animation: load1 .2s linear forwards;}

.progress_2:nth-of-type(2) .right, .progress_2:nth-of-type(3) .right {animation: load2 .2s linear forwards 2s;}

.progress_2:last-of-type .right, .progress_2:first-of-type .right {animation: load3 .2s linear forwards .2s;}

@keyframes load1 {
  0% {transform: rotate(0deg);}

  100% {transform: rotate(180deg);}
}

@keyframes load2 {
  0% {z-index: 100;transform: rotate(180deg);}

  100% {z-index: 100;transform: rotate(270deg);}
}

@keyframes load3 {
  0% {z-index: 100;transform: rotate(180deg);}

  100% {
      z-index: 100;transform: rotate(315deg);}
}

.ttl_img >img{
  width: auto;
  height: 50px;
}

.category {
  display: grid;
  justify-items: center;
  margin-top: 10px;
}
.category > img {
  width: auto;
  height: 50px;
  border-radius: 100px;
  border: 1px solid #FF0066;
}
.category > p {
  font-size: 12px;
  font-weight: 500;
}

/* loyalty Page */
.lylty_cont{
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  height: 160px;
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px 10px 0px 0px;
}
.lylty_item{
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #319bd947;
  border-radius: 10px;
}
.lylty_det{
  max-width: 50% !important;
}

.lylty_desc{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
}
.l_sec >div{
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #2E2E2E;
}
.l_sec >div >img{
 margin-right: 5px;
 width: auto;
 height: 14px;
}


/* nav 2 */
.nav2{
  background: #282828 !important;
  justify-content: start !important;
}
.nav2 >.h_left{
  margin-top: 0  !important;
}
.nav2 >.h_right{
  margin-top: 0  !important;
}
.back_ic{
  width: auto;
  height: 16px;
}
.nav_text{
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}
.nav_inf{
  display: flex !important;
  align-items: center;
}

.see_at{
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
}
.see_at > .l_item{
  width: 30%;
  font-size: 16px;
  background: #ffffff;
  padding: 7px;   
  border-radius: 10px;
  margin: 5px 5px 5px 0px;
  box-shadow: 0px 6px 15px #319bd947;
}
.see_at > .l_item >img{
  width: auto;
  height: 100px;
}
.played_i{
  font-size: 10px;
  font-weight: 400;
  color: #282828;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.played_i >img{
  width: auto;
  height: 12px;
  margin-right: 10px;
}

@media screen and (max-width: 900px){
  .see_at > .l_item{
      width: 30%;
      font-size: 14px;
      background: #ffffff;
      padding: 7px;   
      border-radius: 10px;
      margin: 5px 5px 5px 0px;
      box-shadow: 0px 6px 15px #319bd947;
  }
  .see_at > .l_item >img{
      width: auto;
      height: 80px;
  }
}

@media screen and (max-width: 600px){
  .see_at > .l_item{
      width: 31%;
      font-size: 14px;
      background: #ffffff;
      padding: 7px;   
      border-radius: 10px;
      margin: 5px 5px 5px 0px;
      box-shadow: 0px 6px 15px #319bd947;
  }
  .see_at > .l_item >img{
      width: auto;
      height: 80px;
  }
}




.inner_page {
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
}
.inner_page > a {
  margin-bottom: 30px;
  font-size: 14px;
  color: #223263 !important;
  font-weight: bold;
}
.inner_page > a:hover {
  color: #FF0066 !important;
}


.quiz_inff{
  background: #0e0e0e;
  margin-top: -20px;
  padding: 20px;
}
.q_name{
  margin: 0;
  color: #ffffff;
  margin-bottom: 10px;
}

.quiz_ic_btn{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
}
.quiz_ic_btn >img{
  width: auto;
  height: 100px;
  border-radius: 10px;
}
.btn_inf_pl{
  border: none;
  padding: 10px 30px;
  width: 100%;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  background: #15ce6a;
}
.btn_inf_pl:focus{
  background: #ffffff !important;
}
.q_inf_more{
  display: flex;
  justify-content: space-between;
  text-align: center;
  color: #636363;
  margin-top: 20px;
  align-items: center;
}
.q_inf_more >div >p{
  font-size: 12px;
  font-weight: 400;
  color: #c6c6c6;
  margin-bottom: 5px;
}
.q_inf_more >div >h2{
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.q_inf_more >div >h2 >img{
  width: auto;
  height: 20px;
  margin-right: 5px;
}
.quiz_nm223{
  margin-left: 20px;
}
.knw_ttl{
  border: 1px solid #001C39;
  color: #001C39;
  font-size: 18px;
  text-transform: capitalize;
  font-weight: 700;
  border-radius: 100px;
  text-align: center;
  padding: 10px;
  margin: 10px 0px;
}

.story {
  position: relative;
  color: #ffffff;
  border-radius: 20px;
}
.story::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 1%, rgba(180, 180, 180, 0) 30%, rgba(0, 0, 0, 1) 100%);
}
.story>img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 20px;
}
.caption {
  position: absolute;
  bottom: 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 0 10px;
  margin-bottom: 10px;
}
.cap_feed {
  justify-content: space-around;
  cursor: pointer;
}
.cap_feed_btn {
  display: flex;
  align-items: center;
}
.cap_feed_btn > img {
  margin-right: 10px;
}
#count {
  margin-right: 5px;
}
.vs_scrn{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.ic_med{
  width: auto;
  height: 100px;
  border-radius: 10px;
}
.top_info{
  padding: 10px;
}
.player_ic{
  border-radius: 100px;
  border: 2px solid #bbbbbb;
}
.bottom{
  position: fixed;
  bottom: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 480px;
  padding: 20px;
}
.bottom >button{
  width: 100%;
  margin: 10px;
  border-radius: 10px;
  border: none;
  padding: 10px;
  background: #43a1ff;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
}
.bottom >button >img{
  width: auto;
  height: 40px;
}

@media screen and (max-width: 900px){
  .bottom{
      width: 100%;
  }
}

.vs_timer{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.timer_d{
  font-size: 40px;
  font-weight: bold;
  color: #ffffff;
}

.question_scrn{
  /* background: url(../src/images/question_screen_bg.png); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.options:focus{
  background: #ffffff  ;
}
.quiz_data >img{
  width: auto;
  height: auto;
  max-height: 200px;
}
.q_i_top{
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
}
.q_i_remain{
  border: 1px solid #43a1ff;
  border-radius: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #43a1ff;
  padding: 5px 10px;
  margin: 0;
}
.timer_icn{
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}
.timer_icn >img{
  width: auto;
  height: 20px;
  margin-right: 5px;
}
.quiz_data{
  text-align: center;
  padding: 10px;
}
.ques_txt{
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
}
.options{
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: none;
  margin-top: 10px;
  font-size: 18px;
  font-weight: bold;
}
.wrong_ans{
  background: #FF0066;
  color: #ffffff;
}
.right_ans{
  background: #15ce6a;
  color: #ffffff;
}

.quest_img{
  width: auto;
  height: 150px;
  border-radius: 10px;
}
.imgg_options{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.imgg_options >button{
  width: auto !important;
}
.imgg_options >button > img{
  height: 100px !important;
}

@media screen and (max-width: 900px){
  .imgg_options >button > img{
      height: 180px !important;
  }
}

@media screen and (max-width: 600px){
  .imgg_options >button > img{
      height: 80px !important;
  }
}

.summary_scrn{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
  background-repeat: no-repeat;
  background-size: cover !important;
  background-position: center;
  text-align: center;
}
.yo_won{
  font-size: 22px;
  font-weight: bold;
  color: #00a1ff;
}
.coins_won{
  width: auto;
  height: 80px;
}
.coin_val_earn{
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}
.score_t{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}
.score_t >p{
  color: #15ce6a;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
.score_val{
  font-size: 22px !important;
  font-weight: bold !important;
  border: 1px solid #15ce6a;
  border-radius: 10px;
  padding: 0px 10px;
  min-width: 30%;
  
}
.btn_mores_btm >a{
  color: coral;
  text-decoration: underline;
}

.disable{
  opacity: .5;
}

.loose{
  color: #FF0066;
}

/* button:focus{
  outline: none;
  background-color: #00a1ff !important; 
} */

.coin_inf_p{
  display: flex;
}
.coin_img_p_left >img{
  width: auto;
    height: 120px;
    margin-right: -60px;
    position: relative;
    z-index: 99;
}
.coin_img_p_right >img{
  width: 100%;
  height: auto;
}
.coin_img_p_right{
  position: relative;
  height: -webkit-fill-available;
}
.coin_img_p_right >div{
  position: absolute;
  top: 0%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: -webkit-fill-available;
}
.coin_img_p_right >div >h2{
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}
.coin_bl_inf{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.coin_bl_inf >p{
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.coin_bl_inf >p>img{
  width: auto;
  height: 20px;
  margin-right: 10px;
}

.check_his_wal{
  font-size: 10px;
  font-weight: bold;
  color: #ffffff;
  background: #00a1ff;
  border-radius: 5px;
  padding: 5px;
  border: none;
  margin-top: 5px;
  cursor: pointer;
}



.navigation {
 width: 100%;
 height: 70px;
 background: #0a0022;
 position: relative;
 display: flex;
 justify-content: center;
 align-items: center;
 border-radius: 10px;
 padding: 0 20px;
}
.navigation .listWrap {
 list-style: none;
 display: flex;
 justify-content: space-between;
 width: 100%;
}
.navigation .listWrap li {
 width: 70px;
 height: 70px;
 position: relative;
 z-index: 1;
}
.navigation .listWrap li a {
 text-decoration: none;
 position: relative;
 display: flex;
 justify-content: center;
 align-items: center;
 flex-direction: column;
 text-align: center;
 font-weight: 500;
 width: 100%;
}
.navigation .listWrap li a:hover {
 text-decoration: none;
}
.navigation .listWrap li a .icon {
 position: relative;
 display: block;
 line-height: 75px;
 text-align: center;
 transition: 0.5s;
 color: var(--bg-default);
}
.navigation .listWrap li a .icon ion-icon {
 font-size: 2.2rem;
}
.navigation .listWrap li a .text {
 position: absolute;
 color: var(--bg-default);
 font-weight: 400;
 letter-spacing: 0.05em;
 transition: 0.5s;
 transform: translateY(20px);
 opacity: 0;
 z-index: 1;
}
.navigation .listWrap li:active a .icon, .navigation .listWrap li.active a .icon {
 color: var(--primary-white);
 transform: translateY(-32px);
}
.navigation .listWrap li:active a .text, .navigation .listWrap li.active a .text {
 opacity: 1;
 transform: translateY(10px);
}
.navigation .listWrap li.indicator {
 position: absolute;
 width: 70px;
 height: 70px;
 top: -50%;
 border-radius: 50%;
 border: 6px solid var(--bg-default);
 background: #00a1ff;
 transition: 0.3s;
 z-index: 0;
}
.navigation .listWrap li.indicator:before, .navigation .listWrap li.indicator:after {
 content: '';
 position: absolute;
 top: 50%;
 width: 20px;
 height: 20px;
 background: blue;
 background: transparent;
}
.navigation .listWrap li.indicator:after {
 right: -22px;
 box-shadow: -1px -10px 0 0 var(--bg-default);
 border-top-left-radius: 20px;
}
.navigation .listWrap li.indicator:before {
 left: -22px;
 box-shadow: 1px -10px 0 0 var(--bg-default);
 border-top-right-radius: 20px;
}
.navigation .listWrap li:nth-child(1).active ~ .indicator {
 transform: translateX(calc(70px * 0));
}
.navigation .listWrap li:nth-child(2).active ~ .indicator {
 transform: translateX(calc(70px * 1 + (6px * 2)));
}
.navigation .listWrap li:nth-child(3).active ~ .indicator {
 transform: translateX(calc(70px * 2 + (6px * 4) + 1px));
}
.navigation .listWrap li:nth-child(4).active ~ .indicator {
 transform: translateX(calc(70px * 3 + (6px * 6) + 2px));
}



/* added on 08/07/2024 */
.mrgin_10_tb{
  margin: 0px;
}
.ldr_list{
  background: #282828;
  padding: 10px;
  border-radius: 5px;
  color: #ffffff;
  margin: 5px;
}
.ldr_itm{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ldr_sb_itm{
  display: flex;
  align-items: center;
}

.ldr_sb_itm >p{
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
}
.ldr_sb_itm>h2{
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}
.ldr_itm >p{
  font-size: 12px;
  font-weight: 600;
  margin-top: 5px;
}
.ldr_itm > p > span{
  font-size: 12px;
  font-weight: 500;
}

.text_detl{
  font-size: 10px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  padding: 10px;
}

.text_options{
  flex-direction: column;
}
.right:focus{
  background: #15ce6a;
  color: #ffffff;
}
.wrong:focus{
  background: #fc3737;
  color: #ffffff;
}

.tab_active{
  background: #538bff !important;
}

.tabs .tab{
  width: 100%  !important;
}
.game{
    background: #181818;
    display: flex;
    align-items: center;
    border-radius: 10px;
    color: #ffffff;
    margin-bottom: 10px;

}
.game_img >img{
  width: auto;
  height: 150px;
  border-radius: 10px 0px 0px 10px;
}
.game_list{
  padding: 10px;
  background: #010101;
  position: relative;
  /* margin: 10px; */
  border-radius: 20px 20px 0px 0px;
  min-height: 80vh;
}

.d_flex{
    display: flex;
    justify-content: center;
}
.d_flex > p{
    background: #181818;
    border-radius: 100px;
    padding: 2px 5px;
    font-size: 12px;
    font-weight: 400;
    padding: 2px 10px;
    margin-top: 5px;
}
.game_info{
    padding: 5px 10px;
    width: 100%;
}
.game_info > p{
    font-size: 14px;
    font-weight: 500;
}
.entr2{
    max-width: 100%;
}

.btn_gren{
    background: #538bff;
    width: 100%;
    border-radius: 100px;
    cursor: pointer;
    height: 30px;
}
.btn_gren:focus{
  background: #538bff;
}
.bottom-right {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    bottom: -10px;
    text-align: center;
    background: #000000d0;
    padding: 5px;
}

.game_img{
    position: relative;
    display: flex;
    align-items: center;
}
.played >p{
    text-transform: capitalize;
    font-size: 12px;
    font-weight: 500;
}
.flexx{
    display: flex;
    justify-content: space-between;
    margin: 10px 0px;
    align-items: center;
}

.game_det{
    padding: 0px 10px;
    margin-top: 10px;
    color: #ffffff;
}

.htp{
    background: #282828;
    border-radius: 2px;
    padding: 5px 10px;
    border: none;
    color: #ffffff;
    cursor: pointer;
    font-size: 12px;
}
.htp:focus{
  background: #282828;
  color: #ffffff;
}
.flexx2{
    justify-content: space-around;
}
.flexx >div{
    display: flex;
    align-items: center;
    flex-direction: column;
}

.flexx >div >img{
    width: auto;
    height: 22px;
}

.flexx >div >p{
    font-size: 9px;
}

.text_bg{
    font-size: 16px;
    font-weight: 600;
}
.redd{
    color: #538bff;
    font-size: 16px !important;
}
.bluee{
    color: #538bff;
    font-size: 16px !important;
}
.txt_t{
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    margin-bottom: 10px;
}
.txt_d{
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 10px;
}
.btm_fix{
    position: relative;
    bottom: 0;
    left: 0;
    max-width: 460px;
    width: 100%;
}
.btm_fix >button{
  height: 38px !important;
}

.level_img{
    padding: 10px;
}
.level_img >img{
    width: auto;
    height: 60px;
}

.disable{
    opacity: 0.7;
    filter: grayscale(1);

}

.modal-content >h4{
    color: #282828 !important;
    font-size: 16px !important;
    font-weight: bold !important;
}
.modal-content >p{
    color: #282828 !important;
    font-size: 12px !important;
}

.entr_fee{
    border: 2px dashed #282828;
    background: #ededed;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    padding: 10px;
    border-radius: 5px;
    
}
.entr_fee >img{
    width: auto;
    height: 22px;
}
.modal-content{
    text-align: center !important;
}

.level_complete{
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ffffff;
}
.level_complete >h2{
    font-size: 16px;
    font-weight: 600;
}
.level_complete >p{
    font-size: 12px;
    font-weight: 600;
}
.margin10{
    margin: 10px 0px;
}
.score{
    background-color: #282828;
    color: #ffffff;
    width: 100%;
    border: 1px dashed #5f5f5f;
    font-size: 16px !important;
}


.ldr_center{
  height: 20vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top_img_bane{
  width: 100%;
  height: auto;
  margin-top: -20px;
}


.footernav1 {
  color: #FFFFFF !important;
  max-width: 480px;
  width: 100%;
  text-align: center;
  margin-bottom: auto;
  bottom: 0px;
  padding: 10px;
  background: #282828;
  font-size: 12px;
}

.daimond_redm{
  background: #354055;
  color: #ffffff;
  justify-content: center;
  margin-top: 10p;
  font-size: 14px !important;
  padding: 2px 5px;
  border-radius: 5px;
}

.mrgn_10{
  margin: 10px 0px;
}


.wallet_pg{
    background: #282828;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 15px;
    align-items: center;
    margin: 5px;
    color: #ffffff;
    width: 100%;
}
.ttl_txt{
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #b9b9b9;
    letter-spacing: 2px;
    text-transform: uppercase;
}
.ttl_balance{
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    display: flex;
    align-items: center;
    background: #354055;
    color: #538bff;
    padding: 10px;
    border-radius: 5px;
}
.ttl_balance >img{
    width: auto;
    height: 20px;
    margin-right: 10px;
}


.btm_btn_fx{
  position: fixed;
  bottom: 10%;
  padding: 10px;
  width: 100%;
  max-width: 480px;
}
.btm_btn_fx >button{
  height: 48px;
  background: #282828;
  border: 1px solid #538bff;
  color: #538bff;
}
.btm_btn_fx >button:focus{
  height: 48px;
  background: #282828;
  border: 1px solid #538bff;
  color: #538bff;
}
.pdng_10{
  padding: 0px 10px;
  margin: 10px 0px;
}

.ldr_sb_itm >img{
  width: auto;
  height: 16px;
  margin-right: 5px;
  border-radius: 0;
}

.tming{
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    color: #b9b9b9;
}


.err{
  margin: 10px;
}

.err_imag{
  width: auto;
  height: 250px;
  margin: 0;
}


/* / login / */
  .center_data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.ttl2 {
  font-size: 22px;
}
.link_url {
  color: #9E9E9E;
  font-size: 12px;
}
.mt_10 {
  margin-top: 10px;
}
hr.divider {
  height: 1px;
  margin: 30px 0;
  padding: 0;
  overflow: visible;
  border: none;
  background-color: #282828;
  color: #b6b6b6;
  text-align: center;
  width: 100%;
  font-size: 12px;
}
.divider {
  height: 1px;
  overflow: hidden;
  background-color: #282828;
}
hr.divider:after {
  content: 'or continue with';
  display: inline-block;
  position: relative;
  top: -7px;
  padding: 0 16px;
  background: #181818;
}
.d_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0px;
}
.flex_2 {
  width: 90%;
  justify-content: space-evenly;
}
.btn_cont_with {
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #9E9E9E;
  background: none;
  border: 1px solid #282828 !important;
}
.btn_cont_with:focus {
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #9E9E9E;
  background: none;
  border: 1px solid #282828 !important;
}
.flex_2 >button {
  margin: 5px;
}
.btn_blue2 {
  font-weight: bold;
  border: none;
  padding: 10px;
  min-height: 48px;
  width: 100%;
  border-radius: 5px;
  margin: 5px 0px;
}

.btn_cont_with >img {
  width: auto;
  height: 20px;
  margin-right: 12px;
}

input{
  color: #ffffff;
}

.select-wrapper input.select-dropdown{
  font-size: 12px !important;
}
.main_body_area {
  padding: 0px 10px;
  margin-top: 70px;
}

.dropdown-content li>a, .dropdown-content li>span{
  color: #538bff !important;
  font-size: 12px !important;
}
.btn_ht{
  height: 48px;
}
.g_ads {
  text-align: center;
}
.sponsored {
  text-align: center;
  color: #ffffff;
  font-size: 10px;
  margin: 10px 0px 30px 0px;
}


.full_screen_ad{
  height: 100vh;
  position: absolute;
  top: 0;
  background: #000000cc;
  width: 100%;
  max-width: 480px;
}
.cross{
  display: flex;
  color: #ffffff;
  justify-content: flex-end;
  padding: 10px;
  font-size: 30px;
  cursor: pointer;
}
.disnon{
display: none;
}

.mrgn_0{
  margin-top: 0px !important;
}
.error-message{
  color:red;
}

.l_btn{
  margin-top: -5px !important;
}
.btm_nav {
  background: #282828;
  position: fixed;
  bottom: 0;
  width: 480px;
  z-index: 9;
  height: 70px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.btm_nav >a {
  display: grid;
  justify-items: center;
  width: 100%;
  text-align: center;
  filter: grayscale(1);
  opacity: 0.7;
  gap: 0.5rem;
  padding: 5px;
}
.btm_nav >a >img {
  width: auto;
  height: 25px;
}
.btm_nav > a > p {
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  margin-top: -5px;
}
/* /* .btm_active>p {
  color: #538bff !important;
} */
.btm_active {
  filter: none !important;
    opacity: 1 !important;
    background: #1a1a1a;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #343434;
} 

@media screen and (max-width: 600px) {
  .btm_nav {
      width: 100%;
  }
}



.footernav1 {
  color: #FFFFFF !important;
  max-width: 480px;
  width: 100%;
  text-align: center;
  margin-bottom: auto;
  bottom: 0px;
  padding: 10px;
  background: #101010;
  font-size: 10px;
  /* margin-bottom: 20%; */
  margin-top: 10px;
}

iframe{
  height: 100vh;
  border: none;
  margin-top: -5%;
}

.btn_wd{
  width: auto !important;
  margin: 0 !important;
}
.img_24{
  width: auto;
  height: 24px;
}

.flex_3{
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
}

.mrgn_100{
  margin: 10px 0px;
}

.txt_sm2{
  font-size: 12px;
  font-weight: 400;
}


@media screen and (max-width: 1280px) {
  .s_left {
      width: 100%;
      max-width: 100%;
  }
  .s_right {
    display: none;
  }
  .btm_nav, nav{
    width: 100%;
    max-width: 100%;
  }
  .btm_fix{
    max-width: 100%;
  }
  .footernav1{
    max-width: 100%;
  }
}


.g_ads{
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE;MACI,eAAe;MACf,kBAAkB;MAClB,iCAAiC;EACrC;AACF;;AAEA;EACE;MACI,WAAW;EACf;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,qDAAqD;EACrD,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE;MACI,wBAAwB;EAC5B;AACF;;AAEA;EACE;MACI,wBAAwB;EAC5B;;AAEF;;AAEA,eAAe;AACf;EACE,UAAU;AACZ;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yDAA6C;EAC7C,mCAAmC;EACnC,uCAAuC;EACvC,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,oBAAoB;AACpB;EACE,mDAAwC;EACxC,iCAAiC;EACjC,uCAAuC;EACvC,sCAAsC;EACtC,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mDAA2C;EAC3C,sBAAsB;EACtB,uCAAuC;EACvC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;;AAEhB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,mDAAwC;EACxC,iCAAiC;EACjC,uCAAuC;EACvC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,kCAAkC;EAClC,gBAAgB;AAClB;;;AAGA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;;AAE/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;EACf,uBAAuB;AACzB;;AAEA,mBAAmB,oCAAoC,CAAC;;AAExD,sEAAsE,uCAAuC,CAAC;;AAE9G,mEAAmE,wCAAwC,CAAC;;AAE5G;EACE,IAAI,uBAAuB,CAAC;;EAE5B,MAAM,yBAAyB,CAAC;AAClC;;AAEA;EACE,IAAI,YAAY,CAAC,yBAAyB,CAAC;;EAE3C,MAAM,YAAY,CAAC,yBAAyB,CAAC;AAC/C;;AAEA;EACE,IAAI,YAAY,CAAC,yBAAyB,CAAC;;EAE3C;MACI,YAAY,CAAC,yBAAyB,CAAC;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,iCAAiC;EACjC,uCAAuC;EACvC,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;CACC,iBAAiB;CACjB,WAAW;CACX,YAAY;AACb;;;AAGA,UAAU;AACV;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;MACI,UAAU;MACV,eAAe;MACf,mBAAmB;MACnB,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,kCAAkC;EACtC;EACA;MACI,WAAW;MACX,YAAY;EAChB;AACF;;AAEA;EACE;MACI,UAAU;MACV,eAAe;MACf,mBAAmB;MACnB,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,kCAAkC;EACtC;EACA;MACI,WAAW;MACX,YAAY;EAChB;AACF;;;;;AAKA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EAGnB,oHAAoH;AACtH;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EAGX,aAAa;EAEb,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mDAA+C;EAC/C,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;MACI,WAAW;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2DAA2D;EAC3D,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE;MACI,wBAAwB;EAC5B;AACF;;AAEA;EACE;MACI,uBAAuB;EAC3B;AACF;;AAEA;EACE,8DAAqD;EACrD,4BAA4B;EAC5B,iCAAiC;EACjC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;;AAEhB;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;AACf;AACA;EACE,WAAW;IACT,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;;;AAIA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,aAAa;CACb,8BAA8B;CAC9B,WAAW;AACZ;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;AACzB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,wBAAwB;CACxB,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;CAChB,2BAA2B;CAC3B,UAAU;CACV,UAAU;AACX;AACA;CACC,2BAA2B;CAC3B,4BAA4B;AAC7B;AACA;CACC,UAAU;CACV,2BAA2B;AAC5B;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,mCAAmC;CACnC,mBAAmB;CACnB,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,YAAY;CACZ,4CAA4C;CAC5C,4BAA4B;AAC7B;AACA;CACC,WAAW;CACX,2CAA2C;CAC3C,6BAA6B;AAC9B;AACA;CACC,qCAAqC;AACtC;AACA;CACC,iDAAiD;AAClD;AACA;CACC,uDAAuD;AACxD;AACA;CACC,uDAAuD;AACxD;;;;AAIA,wBAAwB;AACxB;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;;AAEvB;AACA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,YAAY;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;AACA;EACE,uBAAuB;AACzB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,oBAAoB;;AAExB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,kBAAkB;;AAEtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,0BAA0B;IAC1B,0BAA0B;AAC9B;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;;AAGA,cAAc;EACZ;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;AACA,aAAa;AACb;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;;GAEG;AACH;EACE,uBAAuB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;EACE;MACI,WAAW;EACf;AACF;;;;AAIA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE;MACI,WAAW;MACX,eAAe;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,gBAAgB;AAClB","sourcesContent":["*{\n  margin: 0;\n  padding: 0;\n  font-family: \"Poppins\", sans-serif;\n}\nbody{\n  background: #181818;\n  overflow-x: hidden !important;\n}\nbutton, input, optgroup, select, textarea{\n  font-family: \"Poppins\", sans-serif !important;\n}\n.section {\n  display: flex;\n  height: 100vh;\n  align-items: center;\n  overflow: hidden;\n  padding: 0 !important;\n}\n.s_left {\n  /* background: url(../images/white_bg.png); */\n  background: #181818;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  max-width: 480px;\n  width: 100%;\n  overflow-x: hidden !important;\n  overflow-y: scroll;\n  height: 100vh;\n  scroll-behavior: smooth;\n}\n@media screen and (max-width: 900px){\n  .s_left {\n      max-width: 100%;\n      overflow-y: scroll;\n      -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media screen and (max-width: 600px){\n  .s_left {\n      width: 100%;\n  }\n}\n.s_right {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  justify-items: center;\n  background: linear-gradient(135deg, #000000, #000000);\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 100vh;\n  background-position: center;\n  color: #ffffff;\n}\n@media screen and (max-width: 900px){\n  .s_right {\n      display: none !important;\n  }\n}\n\n@media screen and (max-width: 600px){\n  .s_right {\n      display: none !important;\n  }\n  \n}\n\n/* scroll bar */\n::-webkit-scrollbar {\n  width: 4px;\n}\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px #fff3f8; \n}\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(135deg, #ffffff, #ffffff);\n  border-radius: 6px;\n}\n\n/* header */\n.header {\n  height: 60px;\n}\nnav {\n  position: fixed;\n  z-index: 9;\n  max-width: 474px;\n  background: #282828 !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: space-between;\n}\n.h_left {\n  display: flex;\n  align-items: center;\n  width: 100% !important;\n  margin-top: 12px;\n}\n.hamburger {\n  width: auto;\n  height: 40px;\n}\n.sidenav-trigger {\n  display: block !important;\n}\n.logo{\n  width: auto;\n  height: 35px;\n  margin-left: 10px;\n  margin-top: 10px;\n}\n.h_right {\n  display: flex;\n  width: 60%;\n  justify-content: flex-end;\n  margin-top: 10px;\n  margin-right: 10px;\n  gap: 0.5rem;\n}\n.h_right >a > img{\n  width: auto;\n  height: 24px;\n  margin-right: 10px;\n  margin-top: 10px;\n  cursor: pointer;\n}\n.h_right >p{\n  margin-right: 10px;\n  margin-top: -5px;\n  cursor: pointer;\n}\n.daily_st{\n  background: #ffffff;\n  box-shadow: 0px 0px 12px #319bd92e;\n  width: 100%;\n  border-radius: 10px;\n}\n\n.body_sec{\n  padding: 0px 15px;\n}\n\n/* daily streak */\n.daily_st{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n}\n\n.s_l_ttl{\n  background: #dcefff;\n  padding: 0px 0px 0px 5px;\n  border-radius: 5px;\n  font-size: 12px;\n  color: #282828;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  display: inline-flex;\n}\n.mr_l5{\n  margin-left: 5px;\n}\n.s_ic_list{\n  background-image: url(../src/images/s_ic.png);\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  margin-right: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.s_ic_list >p{\n  font-size: 10px;\n  font-weight: 700;\n}\n.s_ic_list >img{\n  position: absolute;\n  height: 24px;\n}\n\n.st_ic_d{\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.task_cmp{\n  border: 1px solid #cfcfcf;\n  border-radius: 5px;\n  margin-top: 10px;\n  padding: 0px 10px;\n}\n.task_cmp > p{\n  display: flex;\n  align-items: center;\n  font-size: 10px;\n  font-weight: bold;\n  color: #464646;\n}\n.task_cmp >p > img{\n  width: auto;\n  height: 15px;\n  margin: 0px 10px;\n}\n.desc_sm{\n  font-size: 10px;\n  color: #464646;\n  font-weight: 400;\n  margin-top: 10px;\n}\n\n.streak_r > p > img{\n  width: auto;\n  height: 30px;\n}\n.streak_r > p{\n  display: flex;\n  align-items: center;\n  border: 1px solid #cfcfcf;\n  border-radius: 50px;\n  padding: 0px 10px 0px 0px;\n  background: #f3f3f3;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.top_b{\n  width: 100%;\n  height: auto;\n  border-radius: 20px;\n  margin-top: 20px;\n  max-height: 250px;\n}\n\n\n/* quiz items listing */\n.h_quiz_list{\n  background: #ffe4e4;\n  margin-top: 10px;\n  border-radius: 10px;\n  padding: 10px;\n}\n.list_c_2{\n  background: #d6f7ff;\n}\n.q_l_head{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.l_ttl{\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.see_all{\n  font-size: 12px;\n  color: #363636;\n  font-weight: 500;  \n}\n\n.l_items{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n}\n.l_item{\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  margin-top: 10px;\n  cursor: pointer;\n}\n.l_item >img{\n  width: auto;\n  height: 70px;\n  border-radius: 10px;\n}\n\n.l_item2 >img{\n  width: auto;\n  height: 200px;\n  border-radius: 10px;\n  margin-top: 10px;\n  cursor: pointer;\n}\n.l_item3{\n  cursor: pointer;\n}\n.l_item3 >img{\n  width: auto;\n  height: 150px;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n\n.chllng{\n  display: flex;\n  align-items: center;\n}\n.chllng >a{\n  margin-right: 10px;\n  color: #282828;\n  background: #cfcfcf;\n  border-radius: 50px;\n  padding: 2px 10px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.home_invite{\n  width: 100%;\n  height: 180px;\n  border-radius: 30px;\n  margin-top: 20px;\n}\n\n\n/* tournament page */\n.trnmnt_header{\n  background: url(../src/images/games.jpg);\n  background-size: cover !important;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  height: 220px;\n  margin-top: -10px;\n}\n.trnmnt_header >img{\n  width: 100%;\n  height: 250px;\n}\n\n.trnmt_list{\n  padding: 10px;\n  border-radius: 30px 30px 0px 0px;\n  z-index: 999;\n  height: 100%;\n}\n\n.trnm_list{\n  background: url(../src/images/champion.jpg);\n  background-size: cover;\n  background-repeat: no-repeat !important;\n  background-position: center;\n  height: 140px;\n  border-radius: 10px;\n  margin-top: 10px;\n  padding: 10px 15px;\n  border: 1px solid #282828;\n}\n.entr{\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n  justify-content: space-between;\n  text-align: center;\n  /* width: 40%; */\n  max-width: 60%;\n  \n}\n.tour_ttl{\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: bold;\n  margin: 0;\n}\n.entry_value > p{\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 500;\n  color: #b9b9b9;\n}\n.entry_value > p >img{\n  width: auto;\n  height: 20px;\n  margin-right: 5px;\n}\n\n.etry_am{\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: #ffffff !important;\n}\n.btn_white{\n  background: #ffffff;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 30px;\n  padding: 7px 20px;\n  border: none;\n  margin-top: 5px;\n}\n\n/* indicator */\n.tabs .indicator {\n  background-color: #319bd9 !important;\n}\n\n.tabs .tab a {\n  color: #ffffff !important;\n  font-weight: 500;\n  font-size: 10px !important;\n  text-transform: capitalize !important;\n}\n\n.tabs{\n  border-radius: 50px;\n  /* text-align: center; */\n  background: #010101 !important;\n  display: flex;\n  justify-content: space-around;\n  height: 40px;\n  align-items: center;\n  cursor: pointer;\n}\n\n/* Free coins section */\n.campgn_item{\n  background: url(../src/images/zuppe.jpg);\n  background-size: cover !important;\n  background-repeat: no-repeat !important;\n  background-position: 100% 0%!important;\n  height: 200px;\n  border-radius: 10px;\n  margin-top: 10px;\n  padding: 10px;\n  display: grid;\n  box-shadow: 0px 3px 12px #00000017;\n  align-items: end;\n}\n\n\n.campgn_det{\n  max-width: 50%;\n}\n.campgn_det >h2{\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0;\n  margin-bottom: 10px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.campgn_det >p{\n  font-size: 12px;\n  font-weight: 400;\n  margin: 0;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.campgn_stps{\n  max-width: 60%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.campgn_stps > p{\n  font-size: 10px;\n  font-weight: bold;\n  color: #282828;\n  background: #dbdbdb;\n  padding: 0px 10px;\n  margin: 5px 5px 5px 0px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  \n}\n.campgn_stps > p >img{\n  width: auto;\n  height: 12px;\n  margin: 0px 5px;\n}\n\n/* Blue Btn */\n.btn_blue{\n  background: #319bd9;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 5px 10px;\n  width: fit-content;\n  border-radius: 5px;\n}\n\n.tabs .tab a:focus, .tabs .tab a:focus.active {\n  background-color: #00a2ff0e !important;\n  outline: none;\n}\n\n.no_task{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50vh;\n  font-size: 12px;\n  font-weight: 500;\n  color: #282828;\n}\n\n/* progreess Bar Circular */\n.c_info_tabs{\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.c_info_tab{\n  background: #ffffff;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  box-shadow: 0px 3px 6px #319bd947;\n}\n.c_info_tab >h2{\n  font-size: 14px;\n  font-weight: bold;\n  color: #282828;\n  margin: 0;\n}\n.progress_2 {\n  width: 70px !important;\n  height: 70px !important;\n  font-size: 30px;\n  color: #fff;\n  border-radius: 50% !important;\n  overflow: hidden !important;\n  position: relative !important;\n  background: #ffffff;\n  text-align: center;\n  margin: 10px !important;\n  display: flex;\n  justify-items: center;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n\n.progress_2 .title {\n  position: relative;\n  z-index: 100;\n  margin: 0;\n  margin-top: 12px;\n}\n\n.progress_2 .overlay {\n  width: 50%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  background-color: #ffffff;\n}\n\n.progress_2 .left, .progress_2 .right {\n  width: 50%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border: 10px solid #00a1ff;\n  border-radius: 100px 0px 0px 100px;\n  border-right: 0;\n  transform-origin: right;\n}\n\n.progress_2 .left {animation: load1 .2s linear forwards;}\n\n.progress_2:nth-of-type(2) .right, .progress_2:nth-of-type(3) .right {animation: load2 .2s linear forwards 2s;}\n\n.progress_2:last-of-type .right, .progress_2:first-of-type .right {animation: load3 .2s linear forwards .2s;}\n\n@keyframes load1 {\n  0% {transform: rotate(0deg);}\n\n  100% {transform: rotate(180deg);}\n}\n\n@keyframes load2 {\n  0% {z-index: 100;transform: rotate(180deg);}\n\n  100% {z-index: 100;transform: rotate(270deg);}\n}\n\n@keyframes load3 {\n  0% {z-index: 100;transform: rotate(180deg);}\n\n  100% {\n      z-index: 100;transform: rotate(315deg);}\n}\n\n.ttl_img >img{\n  width: auto;\n  height: 50px;\n}\n\n.category {\n  display: grid;\n  justify-items: center;\n  margin-top: 10px;\n}\n.category > img {\n  width: auto;\n  height: 50px;\n  border-radius: 100px;\n  border: 1px solid #FF0066;\n}\n.category > p {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* loyalty Page */\n.lylty_cont{\n  background-size: cover !important;\n  background-repeat: no-repeat !important;\n  background-position: center !important;\n  height: 160px;\n  margin-top: 20px;\n  padding: 20px;\n  border-radius: 10px 10px 0px 0px;\n}\n.lylty_item{\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0px 3px 6px #319bd947;\n  border-radius: 10px;\n}\n.lylty_det{\n  max-width: 50% !important;\n}\n\n.lylty_desc{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n}\n.l_sec >div{\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: bold;\n  color: #2E2E2E;\n}\n.l_sec >div >img{\n margin-right: 5px;\n width: auto;\n height: 14px;\n}\n\n\n/* nav 2 */\n.nav2{\n  background: #282828 !important;\n  justify-content: start !important;\n}\n.nav2 >.h_left{\n  margin-top: 0  !important;\n}\n.nav2 >.h_right{\n  margin-top: 0  !important;\n}\n.back_ic{\n  width: auto;\n  height: 16px;\n}\n.nav_text{\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n.nav_inf{\n  display: flex !important;\n  align-items: center;\n}\n\n.see_at{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: start;\n  align-items: center;\n}\n.see_at > .l_item{\n  width: 30%;\n  font-size: 16px;\n  background: #ffffff;\n  padding: 7px;   \n  border-radius: 10px;\n  margin: 5px 5px 5px 0px;\n  box-shadow: 0px 6px 15px #319bd947;\n}\n.see_at > .l_item >img{\n  width: auto;\n  height: 100px;\n}\n.played_i{\n  font-size: 10px;\n  font-weight: 400;\n  color: #282828;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 10px;\n}\n.played_i >img{\n  width: auto;\n  height: 12px;\n  margin-right: 10px;\n}\n\n@media screen and (max-width: 900px){\n  .see_at > .l_item{\n      width: 30%;\n      font-size: 14px;\n      background: #ffffff;\n      padding: 7px;   \n      border-radius: 10px;\n      margin: 5px 5px 5px 0px;\n      box-shadow: 0px 6px 15px #319bd947;\n  }\n  .see_at > .l_item >img{\n      width: auto;\n      height: 80px;\n  }\n}\n\n@media screen and (max-width: 600px){\n  .see_at > .l_item{\n      width: 31%;\n      font-size: 14px;\n      background: #ffffff;\n      padding: 7px;   \n      border-radius: 10px;\n      margin: 5px 5px 5px 0px;\n      box-shadow: 0px 6px 15px #319bd947;\n  }\n  .see_at > .l_item >img{\n      width: auto;\n      height: 80px;\n  }\n}\n\n\n\n\n.inner_page {\n  padding: 30px 20px;\n  display: flex;\n  flex-direction: column;\n}\n.inner_page > a {\n  margin-bottom: 30px;\n  font-size: 14px;\n  color: #223263 !important;\n  font-weight: bold;\n}\n.inner_page > a:hover {\n  color: #FF0066 !important;\n}\n\n\n.quiz_inff{\n  background: #0e0e0e;\n  margin-top: -20px;\n  padding: 20px;\n}\n.q_name{\n  margin: 0;\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n\n.quiz_ic_btn{\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-top: 10px;\n}\n.quiz_ic_btn >img{\n  width: auto;\n  height: 100px;\n  border-radius: 10px;\n}\n.btn_inf_pl{\n  border: none;\n  padding: 10px 30px;\n  width: 100%;\n  border-radius: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  cursor: pointer;\n  background: #15ce6a;\n}\n.btn_inf_pl:focus{\n  background: #ffffff !important;\n}\n.q_inf_more{\n  display: flex;\n  justify-content: space-between;\n  text-align: center;\n  color: #636363;\n  margin-top: 20px;\n  align-items: center;\n}\n.q_inf_more >div >p{\n  font-size: 12px;\n  font-weight: 400;\n  color: #c6c6c6;\n  margin-bottom: 5px;\n}\n.q_inf_more >div >h2{\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.q_inf_more >div >h2 >img{\n  width: auto;\n  height: 20px;\n  margin-right: 5px;\n}\n.quiz_nm223{\n  margin-left: 20px;\n}\n.knw_ttl{\n  border: 1px solid #001C39;\n  color: #001C39;\n  font-size: 18px;\n  text-transform: capitalize;\n  font-weight: 700;\n  border-radius: 100px;\n  text-align: center;\n  padding: 10px;\n  margin: 10px 0px;\n}\n\n.story {\n  position: relative;\n  color: #ffffff;\n  border-radius: 20px;\n}\n.story::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 1%, rgba(180, 180, 180, 0) 30%, rgba(0, 0, 0, 1) 100%);\n  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 1%, rgba(180, 180, 180, 0) 30%, rgba(0, 0, 0, 1) 100%);\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 1%, rgba(180, 180, 180, 0) 30%, rgba(0, 0, 0, 1) 100%);\n}\n.story>img {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 20px;\n}\n.caption {\n  position: absolute;\n  bottom: 10px;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  padding: 0 10px;\n  margin-bottom: 10px;\n}\n.cap_feed {\n  justify-content: space-around;\n  cursor: pointer;\n}\n.cap_feed_btn {\n  display: flex;\n  align-items: center;\n}\n.cap_feed_btn > img {\n  margin-right: 10px;\n}\n#count {\n  margin-right: 5px;\n}\n.vs_scrn{\n  background: url(../src/images/vs_screen_bg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.ic_med{\n  width: auto;\n  height: 100px;\n  border-radius: 10px;\n}\n.top_info{\n  padding: 10px;\n}\n.player_ic{\n  border-radius: 100px;\n  border: 2px solid #bbbbbb;\n}\n.bottom{\n  position: fixed;\n  bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 480px;\n  padding: 20px;\n}\n.bottom >button{\n  width: 100%;\n  margin: 10px;\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n  background: #43a1ff;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.bottom >button >img{\n  width: auto;\n  height: 40px;\n}\n\n@media screen and (max-width: 900px){\n  .bottom{\n      width: 100%;\n  }\n}\n\n.vs_timer{\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.timer_d{\n  font-size: 40px;\n  font-weight: bold;\n  color: #ffffff;\n}\n\n.question_scrn{\n  /* background: url(../src/images/question_screen_bg.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.options:focus{\n  background: #ffffff  ;\n}\n.quiz_data >img{\n  width: auto;\n  height: auto;\n  max-height: 200px;\n}\n.q_i_top{\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  align-items: center;\n}\n.q_i_remain{\n  border: 1px solid #43a1ff;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #43a1ff;\n  padding: 5px 10px;\n  margin: 0;\n}\n.timer_icn{\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: bold;\n}\n.timer_icn >img{\n  width: auto;\n  height: 20px;\n  margin-right: 5px;\n}\n.quiz_data{\n  text-align: center;\n  padding: 10px;\n}\n.ques_txt{\n  font-size: 24px;\n  font-weight: bold;\n  color: #ffffff;\n}\n.options{\n  width: 100%;\n  padding: 10px;\n  border-radius: 10px;\n  border: none;\n  margin-top: 10px;\n  font-size: 18px;\n  font-weight: bold;\n}\n.wrong_ans{\n  background: #FF0066;\n  color: #ffffff;\n}\n.right_ans{\n  background: #15ce6a;\n  color: #ffffff;\n}\n\n.quest_img{\n  width: auto;\n  height: 150px;\n  border-radius: 10px;\n}\n.imgg_options{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n}\n.imgg_options >button{\n  width: auto !important;\n}\n.imgg_options >button > img{\n  height: 100px !important;\n}\n\n@media screen and (max-width: 900px){\n  .imgg_options >button > img{\n      height: 180px !important;\n  }\n}\n\n@media screen and (max-width: 600px){\n  .imgg_options >button > img{\n      height: 80px !important;\n  }\n}\n\n.summary_scrn{\n  background: url(../src/images/vs_bg_2.png) !important;\n  background-repeat: no-repeat;\n  background-size: cover !important;\n  background-position: center;\n  text-align: center;\n}\n.yo_won{\n  font-size: 22px;\n  font-weight: bold;\n  color: #00a1ff;\n}\n.coins_won{\n  width: auto;\n  height: 80px;\n}\n.coin_val_earn{\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n.score_t{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 10px;\n}\n.score_t >p{\n  color: #15ce6a;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n.score_val{\n  font-size: 22px !important;\n  font-weight: bold !important;\n  border: 1px solid #15ce6a;\n  border-radius: 10px;\n  padding: 0px 10px;\n  min-width: 30%;\n  \n}\n.btn_mores_btm >a{\n  color: coral;\n  text-decoration: underline;\n}\n\n.disable{\n  opacity: .5;\n}\n\n.loose{\n  color: #FF0066;\n}\n\n/* button:focus{\n  outline: none;\n  background-color: #00a1ff !important; \n} */\n\n.coin_inf_p{\n  display: flex;\n}\n.coin_img_p_left >img{\n  width: auto;\n    height: 120px;\n    margin-right: -60px;\n    position: relative;\n    z-index: 99;\n}\n.coin_img_p_right >img{\n  width: 100%;\n  height: auto;\n}\n.coin_img_p_right{\n  position: relative;\n  height: -webkit-fill-available;\n}\n.coin_img_p_right >div{\n  position: absolute;\n  top: 0%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  width: 100%;\n  height: -webkit-fill-available;\n}\n.coin_img_p_right >div >h2{\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.coin_bl_inf{\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.coin_bl_inf >p{\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n}\n.coin_bl_inf >p>img{\n  width: auto;\n  height: 20px;\n  margin-right: 10px;\n}\n\n.check_his_wal{\n  font-size: 10px;\n  font-weight: bold;\n  color: #ffffff;\n  background: #00a1ff;\n  border-radius: 5px;\n  padding: 5px;\n  border: none;\n  margin-top: 5px;\n  cursor: pointer;\n}\n\n\n\n.navigation {\n width: 100%;\n height: 70px;\n background: #0a0022;\n position: relative;\n display: flex;\n justify-content: center;\n align-items: center;\n border-radius: 10px;\n padding: 0 20px;\n}\n.navigation .listWrap {\n list-style: none;\n display: flex;\n justify-content: space-between;\n width: 100%;\n}\n.navigation .listWrap li {\n width: 70px;\n height: 70px;\n position: relative;\n z-index: 1;\n}\n.navigation .listWrap li a {\n text-decoration: none;\n position: relative;\n display: flex;\n justify-content: center;\n align-items: center;\n flex-direction: column;\n text-align: center;\n font-weight: 500;\n width: 100%;\n}\n.navigation .listWrap li a:hover {\n text-decoration: none;\n}\n.navigation .listWrap li a .icon {\n position: relative;\n display: block;\n line-height: 75px;\n text-align: center;\n transition: 0.5s;\n color: var(--bg-default);\n}\n.navigation .listWrap li a .icon ion-icon {\n font-size: 2.2rem;\n}\n.navigation .listWrap li a .text {\n position: absolute;\n color: var(--bg-default);\n font-weight: 400;\n letter-spacing: 0.05em;\n transition: 0.5s;\n transform: translateY(20px);\n opacity: 0;\n z-index: 1;\n}\n.navigation .listWrap li:active a .icon, .navigation .listWrap li.active a .icon {\n color: var(--primary-white);\n transform: translateY(-32px);\n}\n.navigation .listWrap li:active a .text, .navigation .listWrap li.active a .text {\n opacity: 1;\n transform: translateY(10px);\n}\n.navigation .listWrap li.indicator {\n position: absolute;\n width: 70px;\n height: 70px;\n top: -50%;\n border-radius: 50%;\n border: 6px solid var(--bg-default);\n background: #00a1ff;\n transition: 0.3s;\n z-index: 0;\n}\n.navigation .listWrap li.indicator:before, .navigation .listWrap li.indicator:after {\n content: '';\n position: absolute;\n top: 50%;\n width: 20px;\n height: 20px;\n background: blue;\n background: transparent;\n}\n.navigation .listWrap li.indicator:after {\n right: -22px;\n box-shadow: -1px -10px 0 0 var(--bg-default);\n border-top-left-radius: 20px;\n}\n.navigation .listWrap li.indicator:before {\n left: -22px;\n box-shadow: 1px -10px 0 0 var(--bg-default);\n border-top-right-radius: 20px;\n}\n.navigation .listWrap li:nth-child(1).active ~ .indicator {\n transform: translateX(calc(70px * 0));\n}\n.navigation .listWrap li:nth-child(2).active ~ .indicator {\n transform: translateX(calc(70px * 1 + (6px * 2)));\n}\n.navigation .listWrap li:nth-child(3).active ~ .indicator {\n transform: translateX(calc(70px * 2 + (6px * 4) + 1px));\n}\n.navigation .listWrap li:nth-child(4).active ~ .indicator {\n transform: translateX(calc(70px * 3 + (6px * 6) + 2px));\n}\n\n\n\n/* added on 08/07/2024 */\n.mrgin_10_tb{\n  margin: 0px;\n}\n.ldr_list{\n  background: #282828;\n  padding: 10px;\n  border-radius: 5px;\n  color: #ffffff;\n  margin: 5px;\n}\n.ldr_itm{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.ldr_sb_itm{\n  display: flex;\n  align-items: center;\n}\n\n.ldr_sb_itm >p{\n  font-size: 12px;\n  font-weight: 500;\n  color: #ffffff;\n}\n.ldr_sb_itm>h2{\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0;\n}\n.ldr_itm >p{\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 5px;\n}\n.ldr_itm > p > span{\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.text_detl{\n  font-size: 10px;\n  font-weight: 500;\n  color: #ffffff;\n  text-align: center;\n  padding: 10px;\n}\n\n.text_options{\n  flex-direction: column;\n}\n.right:focus{\n  background: #15ce6a;\n  color: #ffffff;\n}\n.wrong:focus{\n  background: #fc3737;\n  color: #ffffff;\n}\n\n.tab_active{\n  background: #538bff !important;\n}\n\n.tabs .tab{\n  width: 100%  !important;\n}\n.game{\n    background: #181818;\n    display: flex;\n    align-items: center;\n    border-radius: 10px;\n    color: #ffffff;\n    margin-bottom: 10px;\n\n}\n.game_img >img{\n  width: auto;\n  height: 150px;\n  border-radius: 10px 0px 0px 10px;\n}\n.game_list{\n  padding: 10px;\n  background: #010101;\n  position: relative;\n  /* margin: 10px; */\n  border-radius: 20px 20px 0px 0px;\n  min-height: 80vh;\n}\n\n.d_flex{\n    display: flex;\n    justify-content: center;\n}\n.d_flex > p{\n    background: #181818;\n    border-radius: 100px;\n    padding: 2px 5px;\n    font-size: 12px;\n    font-weight: 400;\n    padding: 2px 10px;\n    margin-top: 5px;\n}\n.game_info{\n    padding: 5px 10px;\n    width: 100%;\n}\n.game_info > p{\n    font-size: 14px;\n    font-weight: 500;\n}\n.entr2{\n    max-width: 100%;\n}\n\n.btn_gren{\n    background: #538bff;\n    width: 100%;\n    border-radius: 100px;\n    cursor: pointer;\n    height: 30px;\n}\n.btn_gren:focus{\n  background: #538bff;\n}\n.bottom-right {\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 90%;\n    bottom: -10px;\n    text-align: center;\n    background: #000000d0;\n    padding: 5px;\n}\n\n.game_img{\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n.played >p{\n    text-transform: capitalize;\n    font-size: 12px;\n    font-weight: 500;\n}\n.flexx{\n    display: flex;\n    justify-content: space-between;\n    margin: 10px 0px;\n    align-items: center;\n}\n\n.game_det{\n    padding: 0px 10px;\n    margin-top: 10px;\n    color: #ffffff;\n}\n\n.htp{\n    background: #282828;\n    border-radius: 2px;\n    padding: 5px 10px;\n    border: none;\n    color: #ffffff;\n    cursor: pointer;\n    font-size: 12px;\n}\n.htp:focus{\n  background: #282828;\n  color: #ffffff;\n}\n.flexx2{\n    justify-content: space-around;\n}\n.flexx >div{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n\n.flexx >div >img{\n    width: auto;\n    height: 22px;\n}\n\n.flexx >div >p{\n    font-size: 9px;\n}\n\n.text_bg{\n    font-size: 16px;\n    font-weight: 600;\n}\n.redd{\n    color: #538bff;\n    font-size: 16px !important;\n}\n.bluee{\n    color: #538bff;\n    font-size: 16px !important;\n}\n.txt_t{\n    font-size: 16px;\n    font-weight: bold;\n    margin: 0;\n    margin-bottom: 10px;\n}\n.txt_d{\n    font-size: 12px;\n    font-weight: 500;\n    margin-bottom: 10px;\n}\n.btm_fix{\n    position: relative;\n    bottom: 0;\n    left: 0;\n    max-width: 460px;\n    width: 100%;\n}\n.btm_fix >button{\n  height: 38px !important;\n}\n\n.level_img{\n    padding: 10px;\n}\n.level_img >img{\n    width: auto;\n    height: 60px;\n}\n\n.disable{\n    opacity: 0.7;\n    filter: grayscale(1);\n\n}\n\n.modal-content >h4{\n    color: #282828 !important;\n    font-size: 16px !important;\n    font-weight: bold !important;\n}\n.modal-content >p{\n    color: #282828 !important;\n    font-size: 12px !important;\n}\n\n.entr_fee{\n    border: 2px dashed #282828;\n    background: #ededed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: bold;\n    padding: 10px;\n    border-radius: 5px;\n    \n}\n.entr_fee >img{\n    width: auto;\n    height: 22px;\n}\n.modal-content{\n    text-align: center !important;\n}\n\n.level_complete{\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #ffffff;\n}\n.level_complete >h2{\n    font-size: 16px;\n    font-weight: 600;\n}\n.level_complete >p{\n    font-size: 12px;\n    font-weight: 600;\n}\n.margin10{\n    margin: 10px 0px;\n}\n.score{\n    background-color: #282828;\n    color: #ffffff;\n    width: 100%;\n    border: 1px dashed #5f5f5f;\n    font-size: 16px !important;\n}\n\n\n.ldr_center{\n  height: 20vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.top_img_bane{\n  width: 100%;\n  height: auto;\n  margin-top: -20px;\n}\n\n\n.footernav1 {\n  color: #FFFFFF !important;\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n  margin-bottom: auto;\n  bottom: 0px;\n  padding: 10px;\n  background: #282828;\n  font-size: 12px;\n}\n\n.daimond_redm{\n  background: #354055;\n  color: #ffffff;\n  justify-content: center;\n  margin-top: 10p;\n  font-size: 14px !important;\n  padding: 2px 5px;\n  border-radius: 5px;\n}\n\n.mrgn_10{\n  margin: 10px 0px;\n}\n\n\n.wallet_pg{\n    background: #282828;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 15px;\n    align-items: center;\n    margin: 5px;\n    color: #ffffff;\n    width: 100%;\n}\n.ttl_txt{\n    margin: 0;\n    font-size: 14px;\n    font-weight: 400;\n    color: #b9b9b9;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n}\n.ttl_balance{\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    background: #354055;\n    color: #538bff;\n    padding: 10px;\n    border-radius: 5px;\n}\n.ttl_balance >img{\n    width: auto;\n    height: 20px;\n    margin-right: 10px;\n}\n\n\n.btm_btn_fx{\n  position: fixed;\n  bottom: 10%;\n  padding: 10px;\n  width: 100%;\n  max-width: 480px;\n}\n.btm_btn_fx >button{\n  height: 48px;\n  background: #282828;\n  border: 1px solid #538bff;\n  color: #538bff;\n}\n.btm_btn_fx >button:focus{\n  height: 48px;\n  background: #282828;\n  border: 1px solid #538bff;\n  color: #538bff;\n}\n.pdng_10{\n  padding: 0px 10px;\n  margin: 10px 0px;\n}\n\n.ldr_sb_itm >img{\n  width: auto;\n  height: 16px;\n  margin-right: 5px;\n  border-radius: 0;\n}\n\n.tming{\n    margin: 0;\n    font-size: 12px;\n    font-weight: 400;\n    color: #b9b9b9;\n}\n\n\n.err{\n  margin: 10px;\n}\n\n.err_imag{\n  width: auto;\n  height: 250px;\n  margin: 0;\n}\n\n\n/* / login / */\n  .center_data {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n.ttl2 {\n  font-size: 22px;\n}\n.link_url {\n  color: #9E9E9E;\n  font-size: 12px;\n}\n.mt_10 {\n  margin-top: 10px;\n}\nhr.divider {\n  height: 1px;\n  margin: 30px 0;\n  padding: 0;\n  overflow: visible;\n  border: none;\n  background-color: #282828;\n  color: #b6b6b6;\n  text-align: center;\n  width: 100%;\n  font-size: 12px;\n}\n.divider {\n  height: 1px;\n  overflow: hidden;\n  background-color: #282828;\n}\nhr.divider:after {\n  content: 'or continue with';\n  display: inline-block;\n  position: relative;\n  top: -7px;\n  padding: 0 16px;\n  background: #181818;\n}\n.d_flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 5px 0px;\n}\n.flex_2 {\n  width: 90%;\n  justify-content: space-evenly;\n}\n.btn_cont_with {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  color: #9E9E9E;\n  background: none;\n  border: 1px solid #282828 !important;\n}\n.btn_cont_with:focus {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  color: #9E9E9E;\n  background: none;\n  border: 1px solid #282828 !important;\n}\n.flex_2 >button {\n  margin: 5px;\n}\n.btn_blue2 {\n  font-weight: bold;\n  border: none;\n  padding: 10px;\n  min-height: 48px;\n  width: 100%;\n  border-radius: 5px;\n  margin: 5px 0px;\n}\n\n.btn_cont_with >img {\n  width: auto;\n  height: 20px;\n  margin-right: 12px;\n}\n\ninput{\n  color: #ffffff;\n}\n\n.select-wrapper input.select-dropdown{\n  font-size: 12px !important;\n}\n.main_body_area {\n  padding: 0px 10px;\n  margin-top: 70px;\n}\n\n.dropdown-content li>a, .dropdown-content li>span{\n  color: #538bff !important;\n  font-size: 12px !important;\n}\n.btn_ht{\n  height: 48px;\n}\n.g_ads {\n  text-align: center;\n}\n.sponsored {\n  text-align: center;\n  color: #ffffff;\n  font-size: 10px;\n  margin: 10px 0px 30px 0px;\n}\n\n\n.full_screen_ad{\n  height: 100vh;\n  position: absolute;\n  top: 0;\n  background: #000000cc;\n  width: 100%;\n  max-width: 480px;\n}\n.cross{\n  display: flex;\n  color: #ffffff;\n  justify-content: flex-end;\n  padding: 10px;\n  font-size: 30px;\n  cursor: pointer;\n}\n.disnon{\ndisplay: none;\n}\n\n.mrgn_0{\n  margin-top: 0px !important;\n}\n.error-message{\n  color:red;\n}\n\n.l_btn{\n  margin-top: -5px !important;\n}\n.btm_nav {\n  background: #282828;\n  position: fixed;\n  bottom: 0;\n  width: 480px;\n  z-index: 9;\n  height: 70px;\n  padding: 0px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n.btm_nav >a {\n  display: grid;\n  justify-items: center;\n  width: 100%;\n  text-align: center;\n  filter: grayscale(1);\n  opacity: 0.7;\n  gap: 0.5rem;\n  padding: 5px;\n}\n.btm_nav >a >img {\n  width: auto;\n  height: 25px;\n}\n.btm_nav > a > p {\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-top: -5px;\n}\n/* /* .btm_active>p {\n  color: #538bff !important;\n} */\n.btm_active {\n  filter: none !important;\n    opacity: 1 !important;\n    background: #1a1a1a;\n    padding: 5px;\n    border-radius: 5px;\n    border: 1px solid #343434;\n} \n\n@media screen and (max-width: 600px) {\n  .btm_nav {\n      width: 100%;\n  }\n}\n\n\n\n.footernav1 {\n  color: #FFFFFF !important;\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n  margin-bottom: auto;\n  bottom: 0px;\n  padding: 10px;\n  background: #101010;\n  font-size: 10px;\n  /* margin-bottom: 20%; */\n  margin-top: 10px;\n}\n\niframe{\n  height: 100vh;\n  border: none;\n  margin-top: -5%;\n}\n\n.btn_wd{\n  width: auto !important;\n  margin: 0 !important;\n}\n.img_24{\n  width: auto;\n  height: 24px;\n}\n\n.flex_3{\n  display: flex;\n  gap: 0.5rem;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.mrgn_100{\n  margin: 10px 0px;\n}\n\n.txt_sm2{\n  font-size: 12px;\n  font-weight: 400;\n}\n\n\n@media screen and (max-width: 1280px) {\n  .s_left {\n      width: 100%;\n      max-width: 100%;\n  }\n  .s_right {\n    display: none;\n  }\n  .btm_nav, nav{\n    width: 100%;\n    max-width: 100%;\n  }\n  .btm_fix{\n    max-width: 100%;\n  }\n  .footernav1{\n    max-width: 100%;\n  }\n}\n\n\n.g_ads{\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
